import { Link } from "react-router-dom";
import SectionEyebrow from "@/components/shared/SectionEyebrow";
import useSeo from "@/lib/useSeo";

const SECTIONS = [
  {
    h: "1. Failed or Undelivered Orders",
    p: "If your order is not delivered due to an issue on IslandHop's side or our partner's side, you are eligible for a full refund.",
  },
  {
    h: "2. Incorrect or Damaged Items",
    p: "Report incorrect or damaged items through the app within 24 hours of delivery to receive a refund or credit. We may request photos for verification.",
  },
  {
    h: "3. Cancellations",
    p: "Orders can be canceled before a driver accepts the delivery. Once a driver has picked up the order, cancellations may incur a partial fee covering the driver's effort.",
  },
  {
    h: "4. Refund Method",
    p: "Refunds are returned to the original payment method within 5–10 business days, or as IslandHop wallet credit if you prefer.",
  },
  {
    h: "5. Disputes",
    p: "Unresolved refund issues can be escalated to support@islandhoptt.com. Our team will review the case in good faith and respond within 3 business days.",
  },
];

export default function RefundPolicy() {
  useSeo({
    title: "Refund Policy",
    description: "IslandHop Technologies LLC Refund Policy — how refunds are processed for orders.",
  });

  return (
    <div data-testid="refund-policy-page">
      <section className="relative pt-20 lg:pt-28 pb-12 border-b border-ih-line overflow-hidden">
        <div className="absolute inset-0 ih-grid-bg opacity-30" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10 space-y-5">
          <SectionEyebrow label="Refunds" color="electric" />
          <h1 className="font-display font-black text-5xl lg:text-6xl text-white">Refund Policy</h1>
          <p className="text-white/40 font-mono text-xs uppercase tracking-[0.18em]">
            Last updated · February 2026
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-5 lg:px-10 space-y-8">
          {SECTIONS.map((s, i) => (
            <div key={i} className="space-y-3">
              <h2 className="font-display font-bold text-2xl text-white">{s.h}</h2>
              <p className="text-white/70 leading-relaxed">{s.p}</p>
            </div>
          ))}

          <div className="mt-12 pt-8 border-t border-ih-line flex flex-wrap gap-3">
            <Link to="/privacy-policy" className={chip(false)} data-testid="legal-tab-privacy">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className={chip(false)} data-testid="legal-tab-terms">
              Terms &amp; Conditions
            </Link>
            <Link to="/refund-policy" className={chip(true)} data-testid="legal-tab-refund">
              Refund Policy
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

const chip = (active) =>
  `px-4 py-2 rounded-full text-sm border transition ${
    active
      ? "bg-white text-black border-white"
      : "border-ih-line2 text-white/70 hover:text-white hover:border-white/30"
  }`;
